import * as React from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import { Link as RouterLink } from "react-router-dom";
import { ListItemIcon } from "@mui/material";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import { routes } from "../../routes/real-estate-routes";

function ListItemLink(props) {
  const { primary, to, description } = props;

  const renderLink = React.useMemo(
    () =>
      React.forwardRef(function Link(itemProps, ref) {
        return <RouterLink to={to} ref={ref} {...itemProps} role={undefined} />;
      }),
    [to]
  );

  return (
    <Card>
      <CardContent>
        <li>
          <ListItem button component={renderLink}>
            <ListItemText primary={primary} />
            <ListItemIcon>
              <ArrowForwardRoundedIcon />
            </ListItemIcon>
          </ListItem>
        </li>
        <Typography>
          {description}
        </Typography>
      </CardContent>
    </Card>
  );
}

export default function NavigationMenu() {
  return (
    <Box>
      <List dense={false}>
        <Grid container spacing={2}>
          {routes.map((route) => {
            return (
              <Grid item xs={12} md={6} key={route.name}>
                <ListItemLink primary={route.name} to={`${route.route_name}`} description={route.description} />
              </Grid>
            );
          })}
        </Grid>
      </List>
    </Box>
  );
}
